import React from 'react'
import HealthcareBanner from './HealthcareBanner'
import HealthcareExcellence from './HealthcareExcellence'
import HealthcareFacility from './HealthcareFacility'
import HealthcareCounter from './HealthcareCounter';
import HealthcareSmart from './HealthcareSmart';
import HealthcarePremise from "./HealthcarePremise";
import HealthcareBrand from './HealthcareBrand';
import HealthcareFaq from './HealthcareFaq';
import HealthcareBusinesse from './HealthcareBusinesse';
import HomeProducts from '../../home/HomeProducts';
export default function Healthcare({ initialData }) {



  const bannerData = {
    head: "Home",
    breadcrumb: [
      {
        slug: "/heathcare-medical-grade-commercial-laundry",
        name: "Healthcare"
      }
    ]

  }


  const Banner = {
    buttonText: "Global Markets",
    buttonLink: "/markets",
    title: "Medical-Grade Washing Systems",
    description: "Supershine provides high-performance laundry systems engineered specifically for the healthcare sector. We ensure your facility meets the highest standards of infection control, linen hygiene, and operational reliability across every ward and department. From patient bedding and OT linen to staff uniforms and isolation garments, every wash cycle is engineered to meet healthcare hygiene standards while ensuring efficiency, durability, and operational consistency.",
    image: "/assets/images/industries-banner1.webp"
  };


  const excellenceData = {
    subtitle: "Meticulous Care Standards",
    title: "Healthcare Laundry Engineered for Reliability and Care",
    description1: "In healthcare environments, laundry operations directly impact patient safety, infection prevention, and overall facility performance. Supershine understands the critical nature of medical linen management—from achieving consistent disinfection to preventing contamination and handling heavy daily loads without delays.",
    description2: "We provide complete on-premise laundry solutions for hospitals, nursing homes, and diagnostic centres. With optimized workflows, intelligent equipment, and expert support, Supershine helps healthcare facilities maintain hygiene compliance, reduce operational stress, and ensure uninterrupted linen availability.",
    buttonText: "Talk to Our Experts",
    buttonLink: "/hospitality-laundry-washing-machine-system"
  };


  const facilityData = {
    title: "Why Supershine <br/> For  Your Healthcare Facility?",
    items: [
      {
        icon: "/assets/images/facility-icon1.webp",
        heading: "Hospital-Grade Hygiene",
        description: " Our systems utilize precise temperature controls and chemical dosing to ensure 100% disinfection, meeting global healthcare microbiology standards."
      },
      {
        icon: "/assets/images/facility-icon2.webp",
        heading: "Advanced Barrier Tech",
        description: "Prevent healthcare-associated infections (HAIs) with our barrier laundry solutions, ensuring zero contact between contaminated and sanitized linen."
      },
      {
        icon: "/assets/images/facility-icon3.webp",
        heading: "Resource Efficiency",
        description: "Reduce operational overheads with low-consumption technology that optimizes water and energy use without sacrificing thermal performance."
      },

      {
        icon: "/assets/images/facility-icon4.webp",
        heading: "Regulatory Compliance",
        description: "Every machine is built to support NABH and international healthcare guidelines, featuring data logging for audit-ready hygiene verification."
      },

      {
        icon: "/assets/images/facility-icon5.webp",
        heading: "Heavy-Duty Reliability",
        description: " Engineered for 24/7 operation, Supershine equipment ensures your facility never faces a linen shortage, even during peak patient occupancy."
      },


      {
        icon: "/assets/images/facility-icon6.webp",
        heading: "Ergonomic Workflow",
        description: "Intelligent automation significantly reduces laundry management time, enabling staff to focus on critical clinical responsibilities."
      }
    ]
  };


  const HeathCareCounter = {
    title: "Our Healthcare Impact in Numbers",
    stats: [
      {
        end: 800,
        suffix: "+",
        text: "Hospital & Healthcare Loads Processed Monthly",
      },
      {
        end: 99,
        suffix: "%",
        text: "Hygiene & Disinfection <br> Compliance Rate",
      },
      {
        end: 500,
        suffix: "+",
        text: "Hospitals, Clinics & Care <br> Facilities Served",
      },
      {
        prefix: "",
        end: 30,
        suffix: "%",
        text: "Average Reduction in Water & Energy Consumption",
      },
    ],
  };

  const Fashionsmart = {
    extraClass: "",
    heading: `Smart Solutions For A Sustainable Future`,
    description: "We design eco-conscious laundry systems that reduce the carbon footprint of your medical facility. By maximizing heat recovery and water recycling, Supershine helps healthcare providers balance life-saving care with environmental responsibility.",
    buttonText: "Learn More",
    buttonLink: "/about",
    altText: "Smart"
  };


  const PremiseData = {
    image: "/assets/images/facilities-image.webp",
    title: "Why Healthcare Facilities Prefer On-Premise Laundry with Supershine?",
    subtitle: "The Key Advantages:",
    reasons: [
      "Maintains complete control over hygiene quality and disinfection standards.",
      "Reduces cross-contamination risks through controlled handling and process segregation.",
      "Ensures faster turnaround and uninterrupted linen availability for critical departments.",
      "Eliminates dependency on external vendors and reduces long-term operational costs.",
      "Designed and supported by Supershine experts—from planning and installation to training and maintenance."
    ],
    buttonText: "Plan Your Laundry",
    buttonLink: "/hospitality-laundry-washing-machine-system"
  };


  const healthcareBrandData = {
    title: "",
    logos: [
      { image: "/assets/images/hospital-logos6.webp", title: "Brand 1" },
      { image: "/assets/images/hospital-logos2.webp", title: "Brand 2" },
      { image: "/assets/images/hospital-logos5.webp", title: "Brand 3" },
      { image: "/assets/images/hospital-new-img1.webp", title: "Brand 4" },
      { image: "/assets/images/hospital-new-img2.webp", title: "Brand 5" },
      { image: "/assets/images/hospital-new-img3.webp", title: "Brand 6" },
      { image: "/assets/images/hospital-logos2.webp", title: "Brand 2" },
      { image: "/assets/images/hospital-logos5.webp", title: "Brand 3" },
    ]
  };



  const businessData = {
    title: "Trusted By Hospitals, <br/> Proven In Practice.",
    description:
      "Hospitals and care facilities rely on Supershine for consistent disinfection standards, dependable equipment, and a commitment to excellence in medical linen processing.",
    testimonials: [
      {
        rating: 5,
        text:
          "“Infection control protocols leave no room for error in linen processing. Supershine's equipment gave us the consistency and thermal disinfection capability our hospital accreditation requires, batch after batch. Our infection control team has signed off on every audit since installation. ”",
        client: "Dr. Sunita Rao, Multi-Specialty Hospital",
      },
      {
        rating: 5,
        text:
          "“With over 600 beds across our network, linen turnaround directly affects patient care. Before Supershine, delays in clean linen availability were a recurring complaint from wards. Now our processing capacity comfortably covers peak demand, even during high admission periods. The shift has been noticeable enough that our nursing staff have actually commented on it.”",
        client: "Vikas Ahuja, Facilities Director, Hospital Network",
      },
      {
        rating: 5,
        text:
          "“As a nursing home, we cannot afford equipment downtime when it comes to hygiene. Supershine's machines have run continuously for months without a single major issue, and the after-sales support has been quick whenever we needed minor servicing. For a smaller facility like ours, that dependability matters as much as the equipment itself.”",
        client: "Latika Sharma, Administrator, Senior Care Facility",
      },
    ],
  };



  const productData = {
    subtitle: "Recommended Products",
    title: "Supershine Technology for <br> Safe & Efficient Healthcare Laundry",
   
  };




  const faqData = {
    title: "FAQs",
    description:
      "Clear answers to help you choose the right healthcare laundry solution confidently.",
    buttonText: "Talk to an expert",
    buttonLink: "/contact",
    faqs: [
      {
        question: " What makes Supershine suitable for healthcare facilities?",
        answer: "Supershine systems are designed for medical environments, offering controlled wash programs, high hygiene performance, durable equipment, and workflow designs that support infection control and operational efficiency.",
      },
      {
        question: " Do Supershine solutions support healthcare hygiene compliance?",
        answer:
          " Yes. Our machines come with predefined programs, monitoring capabilities, and process controls that help healthcare facilities maintain consistent hygiene standards.",
      },
      {
        question: "How energy-efficient are Supershine systems?",
        answer:
          " Supershine equipment is engineered to optimize water, power, and chemical usage, helping facilities reduce operating costs while maintaining performance.",
      },

      {
        question: "What support and maintenance does Supershine provide?",
        answer:
          " We offer end-to-end assistance, including system planning, installation, staff training, preventive maintenance, and responsive service support.",
      },

      {
        question: "Can the system handle isolation or high-risk linen?",
        answer:
          " Yes. Our workflow designs support proper segregation, controlled processing, and safe handling of contaminated or isolation linen.",
      },

      {
        question: "How long does installation take?",
        answer:
          " Installation timelines depend on project size and facility readiness, but our team ensures efficient planning and quick deployment to minimize operational disruption.",
      },
    ],
  };


  return (
    <>

      <HealthcareBanner data={Banner}  breadcrumb={bannerData.breadcrumb}/>
      <HealthcareExcellence data={excellenceData} />
      <HealthcareFacility data={facilityData} />
      <HealthcareCounter data={HeathCareCounter} />
      <HealthcareSmart data={Fashionsmart} />
      <HealthcarePremise data={PremiseData} />
      <HealthcareBrand data={healthcareBrandData} />
      <HealthcareBusinesse data={businessData} />
      <HomeProducts data={productData} extraClass="healthcare-product" initialData={initialData}/>
      <HealthcareFaq data={faqData} />
    </>
  )
}
